import { render, staticRenderFns } from "./FrkDivider.vue?vue&type=template&id=0203e7cf&"
import script from "./FrkDivider.vue?vue&type=script&setup=true&lang=ts&"
export * from "./FrkDivider.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports